/**
 * Kalkulator pozycji i rozmiarów dla elementów Layout JSON.
 * Brak customowej logiki fontSize - rozmiar czcionki pochodzi z definicji layoutu,
 * a Fabric.js Textbox z splitByGrapheme: true pilnuje szerokości.
 */

/**
 * Oblicz rzeczywistą pozycję elementu na canvas
 * @param {object} position - obiekt pozycji z Layout JSON
 * @param {object} canvasDims - wymiary canvas {width, height}
 * @returns {object} - {top, left, width, height}
 */
export function calculatePosition(position, canvasDims) {
    const { width: canvasWidth, height: canvasHeight } = canvasDims;

    if (position.type === 'absolute') {
        return {
            top: position.top,
            left: position.left,
            width: position.width,
            height: position.height
        };
    }

    // Relative positioning (0-1 values)
    return {
        top: position.top * canvasHeight,
        left: position.left * canvasWidth,
        width: position.width
            ? (position.width <= 1 ? position.width * canvasWidth : position.width)
            : undefined,
        height: position.height
            ? (position.height <= 1 ? position.height * canvasHeight : position.height)
            : undefined
    };
}

/**
 * Oblicz rozmiar czcionki (obsługuje wartości procentowe)
 * @param {number|string} fontSize - rozmiar czcionki (liczba lub "10%")
 * @param {number} canvasWidth - szerokość canvas
 * @returns {number} - rozmiar czcionki w px
 */
export function calculateFontSize(fontSize, canvasWidth) {
    if (typeof fontSize === 'number') {
        return fontSize;
    }

    // Percentage of canvas width: "10%"
    if (typeof fontSize === 'string' && fontSize.endsWith('%')) {
        const percent = parseFloat(fontSize) / 100;
        return Math.round(canvasWidth * percent);
    }

    return parseInt(fontSize, 10) || 20;
}
